import {Component, OnInit} from "@angular/core";
import {UsanaObject} from "../usana-object";
import {LoggerService} from "./logger.service";
import {Constants} from "../constants";
import {Util} from "../util/util";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'reload',
    template: '',
    standalone: false
})
export class ReloadComponent extends UsanaObject implements OnInit {

    /**
     * This component is being used as an intermediate step for refreshing the page and forcing a reload of the shopUser.
     * It represents a UI router state that properly triggers unsaved AO changes dialog and allows for a clean simple direct reload of Shop.
     * This reload logic relies on the ajs.index.ts urlProvider.otherwise functionality
     * This solution solved:
     *  removing unwanted state and/or transition params of current state and url
     *  state changes without refreshing the shopUser
     *  state changes being ignored if matched by the current state
     *  unsaved AO dialog blip
     *  unsaved AO remaining in AO management page
     *  reloading a current page that the shopUser might not have access to anymore
     */

    constructor(
        loggerService: LoggerService,
        private route: ActivatedRoute
    ) {
        super(loggerService);
    }

    ngOnInit() {
        this.buildUrl();
    }

    buildUrl() {
        let url: string = Constants.URL_BASE;
        if (this.route.snapshot.queryParamMap.has(Constants.URL)) {
            url += this.route.snapshot.queryParamMap.get(Constants.URL);
        }

        const resetSubdomain: boolean = this.route.snapshot.queryParamMap.has(Constants.RESET_SUBDOMAIN) && Util.parseBoolean(this.route.snapshot.queryParamMap.get(Constants.RESET_SUBDOMAIN));
        url = Util.buildBaseUrl(resetSubdomain) + url;
        this.reloadPage(url);
    }

    reloadPage(url) {
        window.location.replace(url);
    }
}
